export const TODO_CREATE = 'TODO_CREATE';
export const TODO_CHANGE = 'TODO_CHANGE';
export const TODO_DELETE = 'TODO_DELETE';
export const TODO_SELECT = 'TODO_SELECT';
export const TODO_SAVE = 'TODO_SAVE';
export const TODO_SORT = 'TODO_SORT';
export const TODOS_MERGE = 'TODOS/MERGE';
